import { ACTIVE_DARK } from "./actionTypes";

export const activeDark = () =>{
    return{
        type: ACTIVE_DARK
    }
}

 